import React from "react";
import { siteConfig } from "../../config/siteConfig";
import Eyebrow from "../ui/Eyebrow";
import Icon from "../ui/Icon";
import Reveal from "../ui/Reveal";

/**
 * Testimonials — section « Lo que incluye la plataforma » (DESIGN-SPEC §4).
 *
 * Décision produit « pas de témoignages » honorée : la section se masque
 * d'elle-même si les données sont vides. Quand présente, elle rend des cartes
 * SOBRES `.elev-1` (pas de gradient texte, pas de tuile gradient), une rampe
 * typographique cohérente (H2 sobre slate-900, eyebrow via <Eyebrow>) et un
 * stagger <Reveal>. Emoji -> <Icon> via le pattern iconKey/icon de siteConfig.
 */
const Testimonials = () => {
  const { platformIncludes } = siteConfig;
  const items = platformIncludes?.items ?? [];

  // Self-hide : aucune donnée -> on ne rend rien (décision « no testimonials »).
  if (items.length === 0) return null;

  return (
    <section
      id="testimonials"
      className="border-t border-slate-200/70 bg-white py-20 md:py-28"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-3xl mx-auto mb-14">
          {platformIncludes?.eyebrow ? (
            <Eyebrow className="justify-center">{platformIncludes.eyebrow}</Eyebrow>
          ) : null}
          {platformIncludes?.title ? (
            <h2 className="mt-4 mb-5 text-3xl md:text-4xl font-bold tracking-tight text-slate-900 text-balance">
              {platformIncludes.title}
            </h2>
          ) : null}
          {platformIncludes?.subtitle ? (
            <p className="text-lg text-slate-600 leading-snug text-pretty">
              {platformIncludes.subtitle}
            </p>
          ) : null}
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((item, index) => (
            <Reveal
              key={index}
              index={index}
              className="elev-1 rounded-2xl border border-slate-200 bg-white p-7"
            >
              <div className="mb-5 flex h-11 w-11 items-center justify-center rounded-xl bg-indigo-50 text-indigo-700 ring-1 ring-inset ring-indigo-100">
                {item.iconKey ? (
                  <Icon name={item.iconKey} className="w-5 h-5" />
                ) : item.icon ? (
                  <span aria-hidden="true" className="text-xl leading-none">
                    {item.icon}
                  </span>
                ) : null}
              </div>
              <h3 className="mb-2 text-lg font-semibold leading-snug text-slate-900">
                {item.title}
              </h3>
              <p className="text-sm leading-relaxed text-slate-600">
                {item.description}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
